var _rect, _rect2, _circle, _path, _path2, _path3, _path4, _rect3, _rect4, _path5, _path6, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNatuurlijkMixset = function SvgNatuurlijkMixset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "#E2DFDF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.3242,
    cy: 75.6973,
    r: 15.9023,
    fill: "#E7D1BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3223 24.3029C41.7229 24.3029 50.1668 32.7468 50.1668 43.1475C39.7662 43.1475 31.3223 34.7035 31.3223 24.3029Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0106 24.3029C58.6099 24.3029 50.166 32.7468 50.166 43.1475C60.5666 43.1475 69.0106 34.7035 69.0106 24.3029Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 75.6973H75.8631",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4688 50H75.8631",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3242,
    y: 56.8418,
    width: 8.11328,
    height: 11.9922,
    rx: 4.05664,
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8906,
    y: 56.8418,
    width: 8.11328,
    height: 11.9922,
    rx: 4.05664,
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5697 68.834V56.8418L26.6953 60.9873",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5157 68.8339L71.1897 56.8419",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.9043,
    cy: 57.3594,
    r: 2,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.2773,
    cy: 68.3379,
    r: 2,
    fill: "black"
  })));
};
export default SvgNatuurlijkMixset;